import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  RightSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} />

      <Container>
        <LeftSection>
          <CardContainer>
            <SectionHeadingSkeleton />
            <FormLayout>
              <InputSkeleton className="col-span-6" />
              <InputSkeleton className="col-span-6" />
              <InputSkeleton className="col-span-6" />
              <InputSkeleton className="col-span-6" />
              <InputSkeleton className="col-span-6" />
              <InputSkeleton className="col-span-6" />
              <InputSkeleton className="col-span-6" />
              <InputSkeleton className="col-span-6" />
              <InputSkeleton className="col-span-12" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton />
            <FormLayout>
              <InputSkeleton className="col-span-12 h-32 w-48 sm:col-span-6" />
              <div className="col-span-12 flex items-center gap-4">
                <InputSkeleton className="h-32 flex-1" />
                <InputSkeleton className="h-32 flex-1" noLabel />
                <InputSkeleton className="h-32 flex-1" noLabel />
              </div>
            </FormLayout>
          </CardContainer>
        </LeftSection>

        <RightSection>
          <CardContainer right>
            <SectionHeadingSkeleton />
            <PhoneNumberLoading />
          </CardContainer>
        </RightSection>
      </Container>
    </ContainerLayout>
  );
}
